import SponsorDashboardView from "@/views/sponsor/dashboard/DashboardView";

export default [
  {
    name: "pages.sponsor.dashboard",
    path: "dashboard",
    component: SponsorDashboardView
  },
  
];
